import React from 'react';
import { motion } from 'motion/react';
import { User, Crown } from 'lucide-react';

interface UserPostBadgeProps {
  isUserPost: boolean;
  children: React.ReactNode;
}

export function UserPostBadge({ isUserPost, children }: UserPostBadgeProps) {
  if (!isUserPost) return <>{children}</>;

  return (
    <div className="relative">
      {/* Gradient border for user posts */}
      <div className="absolute -inset-[2px] bg-gradient-to-r from-yellow-400 via-orange-500 to-yellow-400 rounded-2xl opacity-60 blur-sm" />
      
      {/* "Your Post" Badge */}
      <motion.div
        initial={{ opacity: 0, y: -10 }}
        animate={{ opacity: 1, y: 0 }}
        className="absolute -top-3 left-4 z-10 flex items-center gap-1.5 px-3 py-1 bg-gradient-to-r from-yellow-500 to-orange-600 text-white rounded-full shadow-lg"
      >
        <Crown className="w-3 h-3" />
        <span className="text-[10px] font-black uppercase tracking-wider">Your Post</span>
      </motion.div>

      {/* Actual content */}
      <div className="relative">
        {children}
      </div>
    </div>
  );
}
